import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {VotingRouting} from '@modules/voting/voting.routing';
import {VotingSectionComponent} from '@modules/voting/voting-section/voting-section.component';
import { VotingItemComponent } from './voting-item/voting-item.component';
import {DirectivesModule} from '@shared/directives/directives.module';
import { VotingNavigationComponent } from './voting-navigation/voting-navigation.component';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {VotingControllerComponent} from '@modules/voting/voting-controller/voting-controller.component';
import {SharedPipesModule} from '@shared/pipes/pipes.module';
import {SharedModule} from '@shared/shared.module';
import { VotingPlayerEventRatingComponent } from './voting-item/voting-player-event-rating/voting-player-event-rating.component';
import {FilterModule} from '@shared/components/filter/filter.module';
import {SharedTabsModule} from '@shared/modules/shared-tabs/shared-tabs.module';


@NgModule({
  declarations: [
    VotingSectionComponent,
    VotingControllerComponent,
    VotingItemComponent,
    VotingNavigationComponent,
    VotingPlayerEventRatingComponent,
  ],
  exports: [
    VotingControllerComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    SharedPipesModule,
    SharedModule,
    FilterModule,
    SharedTabsModule,
  ]
})
export class VotingModule { }
